<div
  [ngClass]="ccClasses"
  [style.height.px]="ccIconHeight"
  [style.width.px]="ccIconWidth"
  [style.background-position-x]="backgroundOffset + 'px'"
  [attr.aria-label]="ariaLabel"
  [attr.role]="roleAttr"
  dsTabFocus
></div>
